(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('medal', {
            parent: 'entity',
            url: '/medal',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.medal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medal/medals.html',
                    controller: 'MedalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('medal-detail', {
            parent: 'medal',
            url: '/medal/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.medal.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/medal/medal-detail.html',
                    controller: 'MedalDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('medal');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Medal', function($stateParams, Medal) {
                    return Medal.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'medal',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('medal-detail.edit', {
            parent: 'medal-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medal/medal-dialog.html',
                    controller: 'MedalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Medal', function(Medal) {
                            return Medal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('medal.new', {
            parent: 'medal',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medal/medal-dialog.html',
                    controller: 'MedalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                badge: null,
                                description: null,
                                textEnglish: null,
                                textJapanese: null,
                                imageBadgeUrl: null,
                                runnerPlaceCondition: null,
                                totalDistanceCondition: null,
                                countOfRunsCondition: null,
                                orderMedal: null,
                                medalKey: null,
                                minDistance: null,
                                maxDistance: null,
                                liveRun: null,
                                soloRun: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('medal', null, { reload: 'medal' });
                }, function() {
                    $state.go('medal');
                });
            }]
        })
        .state('medal.edit', {
            parent: 'medal',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medal/medal-dialog.html',
                    controller: 'MedalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Medal', function(Medal) {
                            return Medal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('medal', null, { reload: 'medal' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('medal.delete', {
            parent: 'medal',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/medal/medal-delete-dialog.html',
                    controller: 'MedalDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Medal', function(Medal) {
                            return Medal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('medal', null, { reload: 'medal' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
